import React, { useMemo } from 'react';
import { get } from 'lodash';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { isGa2Device } from 'common/utils/deviceTwinUtils';
import { toggleDisplayNameForBundles } from 'common/utils/helpers';
import { selectActiveDeviceDisplayMode } from 'redux/selectors';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { PivotSolidIcon } from 'components/icons';
import DevicePill from './DevicePill';
import DeviceStatusBox from './DeviceStatusBox';
import styles from './PivotDeviceCard.module.css';

function PivotDeviceCard({ device, bundle }) {
  const deviceDisplayMode = useSelector(selectActiveDeviceDisplayMode);
  const deviceId = device.deviceId ?? device.id ?? '';
  const deviceName = toggleDisplayNameForBundles(bundle, deviceDisplayMode);
  // @todo pull band info
  // 28 GHz is default for v1.2.0, GA1 devices
  // centerFreq for GA2 can be retrieved from the device twin
  const centerFreq = isGa2Device(device) ? get(device, 'properties.reported.DU.center-freq', null) : '28';
  const allMembers = bundle.members ?? []

  return (
    <div className={styles.root}>
      <div className={classNames(styles.row, styles.header)}>
        <div className={classNames(styles.cell)}>
          <div className={styles.data} data-tip={deviceName}>
            <PivotSolidIcon className={styles.pivotIcon} />
            <Link to={`/console/devices/pivot/overview?deviceId=${deviceId}`} className={styles.pivotLink}>
              {deviceName}
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <div className={classNames(styles.cell, styles.scrollContainer)}>
          <PerfectScrollbar>
            {allMembers.map((member, idx) => (
              <DevicePill
                key={member.deviceId}
                duId={deviceId}
                device={member}
                deviceDisplayMode={deviceDisplayMode}
              />
            ))}
          </PerfectScrollbar>
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.data}>
          <DeviceStatusBox device={device} />
        </div>
        {centerFreq && (
          <div className={styles.data}>
            <div className={styles.centerFreq}>{`${centerFreq} GHz`}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PivotDeviceCard;
